import * as z from 'zod'
import { toTypedSchema } from '@vee-validate/zod'

const domainRegex = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/i

export const resellerSchema = z.object({
  label: z.string({ required_error: 'Label is required' }).min(1, 'Label is required'),
  short_name: z
    .string({ required_error: 'Short Name is required' })
    .min(1, 'Short Name is required'),
  legal_name: z
    .string({ required_error: 'Legal Name is required' })
    .min(1, 'Legal Name is required'),
  trade_name: z.string().optional(),
  portal_domain: z
    .string()
    .regex(domainRegex, 'Invalid domain format (e.g. portal.domain.com)')
    .optional()
    .or(z.literal('')),
  email_domain: z
    .string()
    .regex(domainRegex, 'Invalid domain format (e.g. domain.com)')
    .optional()
    .or(z.literal('')),
  acrobits_cloud_id: z.string().optional().default('QVARA'),
  turnstile_site_key: z.string().optional(),
  turnstile_secret_key: z.string().optional(),
  body_embed_code: z.string().optional().or(z.literal('')),
  feedback_email: z
    .string()
    .email('Must be a valid email address')
    .max(255, 'Must be 255 characters or less')
    .optional()
    .or(z.literal(''))
})

export type ResellerFormValues = z.infer<typeof resellerSchema>

export const resellerTypedSchema = toTypedSchema(resellerSchema)
